import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Pagination, Form, FormControl, FormGroup, ButtonToolbar, Button, InputGroup, DropdownButton, MenuItem, Tabs, Tab } from 'react-bootstrap'
import Select from 'react-select';
import Moment from 'moment';
import CKAutocomplete from '../../component/element/CKAutocomplete';
import FontAwesome from 'react-fontawesome';
import DatePicker from '../../component/element/DatePicker'
import CkTimePicker from '../../component/element/CkTimePicker'
import WorkdocStore from '../../stores/WorkdocStore'
import ReportMobileTable from '../report/ReportMobileTable'
import {connect} from 'react-redux'
var NotificationSystem = require('react-notification-system');

class MechanicWaitPartReport extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading:false,
      data:[],
      approve_flag_0:[],
      approve_flag_1:[],
      approve_flag_2:[],
    }
  }

  componentDidMount() {
  	// this.loadData()
	}
	
	componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData()
    }
  }

  loadData(){
    let that = this
    this.setState({loading:true})
    WorkdocStore.loadMechanicWaitPart(function(result) {	
      that.setState({loading:false,data:result.data})
    })
  }

  onStatusSelect(item,e) {
  	let {data} = this.state
  	item.approve_flag = e
  	this.setState({data:data})

  	let postData = {time_id:item.time_id,status:e}
  	WorkdocStore.saveMechanicWaitPart(postData,function(result) {
  		if (result.status==='OK') {
  	
  		}		
  	})
  }

  renderStatus(index,item,status) {
		let {messages} = this.props
  	if (status==='0') {
  	  return(
  	  	<DropdownButton
	      bsStyle={'default'}
	      title={messages['Pending']}
	      key={index}
	      pullRight
	      onSelect={this.onStatusSelect.bind(this,item)}
	      id={''}
	    >
	      <MenuItem eventKey="1">{messages['Approve']}</MenuItem>
	      <MenuItem eventKey="2">{messages['Not Approved']}</MenuItem>
	    </DropdownButton>
  	  )
  	} else if (status==='1') {
  	  return(messages['Approved'])
  	} else if (status==='2') {
  	  return(messages['Not Approved'])
  	} 
  }

  renderRowData(status) {
		let {data} = this.state
		let {messages} = this.props
    let i = 0
    let check_status = false
    data.forEach(function(item,index) {
    	if (item.approve_flag===status) {
    		check_status = true
    	}
    })

    if (data===undefined||data.length===0||check_status===false) {
      return(<tr><td colSpan={10}>{messages['No Data']}</td></tr>)
    } else {
      return(		
        data.map((item,index) => {
       	  if (item.approve_flag===status) { 
       	    i++	
            return(
              <tr key={index}>
                <td className='text-center'>{i}</td>
                <td className='text-center'>{item.work_no}</td>
                <td className='text-center'>{item.car_registration_no}</td>
                <td>{item.first_name+' '+item.last_name}</td>
                <td>{item.nick_name}</td>
                <td className='text-center'>{item.position}</td>
                <td className='text-center'>{item.department}</td>
                <td className='text-center'>{item.scan_time.substring(0, 10)}</td>
                <td className='text-center'>{item.scan_time.substring(11)}</td>
                <td className='text-center'>{this.renderStatus(index,item,item.approve_flag)}</td>
              </tr>
            )
      	  }
        })
      )
    }
  }

  renderTable(status) {
		let {messages} = this.props
  	return(
  	  <div>
  	    <table className='table table-responsive table-hover table-bordered-solid'>
  	      <thead>
  	        <tr>
  	          <th className='text-center' style={{width:'50px'}}>{messages['No']}</th>
  	          <th className='text-center' style={{width:'120px'}}>{messages['Doc No']}</th>
  	          <th className='text-center' style={{width:'120px'}}>{messages['Car Registration']}</th>
  	          <th className='text-center' style={{width:'300px'}}>{messages['Employee Name']}</th>
  	          <th className='text-center' style={{width:'100px'}}>{messages['Nickname']}</th>
              <th className='text-center' style={{width:'120px'}}>{messages['Position']}</th>
              <th className='text-center' style={{width:'120px'}}>{messages['Department']}</th>
  	          <th className='text-center' style={{width:'120px'}}>{messages['Date']}</th>
  	          <th className='text-center' style={{width:'120px'}}>{messages['Time']}</th>
  	          <th className='text-center' style={{width:'120px'}}>{messages['Status']}</th>
  	        </tr>
  	      </thead>
  	      <tbody>
  	        {this.renderRowData(status)}
  	      </tbody>
  	    </table>
  	  </div>
  	)
  }

  onTabSelect(e) {

	}

	renderWorkStatus(status) {
		let {messages} = this.props
		if (status==='0') {
			return(<span className="label label-default">{messages['Pending']}</span>) 
  	} else if (status==='1') {
			return(<span className="label label-primary">{messages['Approved']}</span>)
  	} else if (status==='2') {
			return(<span className="label label-danger">{messages['Not Approved']}</span>)
  	} 
	}
	
	renderMobileTable(status) {
		let {data} = this.state
		let {messages} = this.props
    let fieldMap = {title:'fullname',amount:'position',sub_title:'car_registration_no',date:'remark',status:'approve_flag',sub_status:''}
    let _data = []
    data.map((item,index)=>{
			if (item.approve_flag===status) {
				let _item = item
				_item = Object.assign({fullname:item.first_name+' '+item.last_name,stock_type_text:(item.stock_type=='tool'?messages['Tool']:item.stock_type=='genpart'?messages['General Part']:messages['Officemate'])}, _item)
      	_data.push(_item)
			}
    })
    return(
      <div>
        <ReportMobileTable
          itemlist={_data}
					fieldMap={fieldMap}
					numberFormat={false}
					renderWorkStatus={this.renderWorkStatus.bind(this)}
        />
      </div>
    )
  }

  render() {
		let {loading} = this.state
		let {isMobile,messages} = this.props
  	return(
  		<div>
  		  <Tabs 
  		    defaultActiveKey={1} 
  		    id="uncontrolled-tab-example"
  		    onSelect={this.onTabSelect.bind(this)}
  		  >
		    <Tab eventKey={1} title={messages['Pending']}>
		      <Box loading={loading}>
		        <Box.Header border={true}>
		          {messages['Parts request approval table']}
			    </Box.Header>
		        <Box.Body>
		          {isMobile?this.renderMobileTable('0'):this.renderTable('0')}
		        </Box.Body>
		      </Box>
		    </Tab>
		    <Tab eventKey={2} title={messages['Approved']}>
		      <Box loading={loading}>
		        <Box.Header border={true}>
		          {messages['Parts request approval table']}
			    </Box.Header>
		        <Box.Body>
		          {isMobile?this.renderMobileTable('1'):this.renderTable('1')}
		        </Box.Body>
		      </Box>
		    </Tab>
		    <Tab eventKey={3} title={messages['Not Approved']}>
		      <Box loading={loading}>
		        <Box.Header border={true}>
		          {messages['Parts request approval table']}
			    </Box.Header>
		        <Box.Body>
		          {isMobile?this.renderMobileTable('2'):this.renderTable('2')}
		        </Box.Body>
		      </Box>
		    </Tab>
		  </Tabs>
	  	</div>    
  	)
  }
} 

export default connect(
  (state) => ({messages: state.message.view.po.MechanicWaitPartReport}),null,null,{withRef:true}
)(MechanicWaitPartReport); 


// WEBPACK FOOTER //
// ./src/view/po/MechanicWaitPartReport.js